module.exports = ".issuealert{\r\n    background: #fbd7d7;\r\n    }\r\n\r\n.issue{\r\n    background: #d5ded6eb;\r\n}\r\n\r\ntd{\r\n    border: 1px solid #ccc\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/telecaller-details/telecaller-details-grid/telecaller-details-grid.component.css
// module id = ./src/app/prospect/telecaller-details/telecaller-details-grid/telecaller-details-grid.component.css
// module chunks = main